import { settings } from "@tumbodash/browserPackages";
import * as Phaser from "phaser";
import phaserMount from "./mount.js";

/**
 * @function config
 * @description Generate a configuration object for a Phaser game
 * @param {string} parentMountId - Id of the parent element to mount Phaser game onto
 * @returns {object} The Phaser game configuration object
 */

function config(parent: string, width = 360, height = 640) {
	var phaserMountElement = phaserMount(parent);

	const phaserConfig = {
		type: Phaser.AUTO,
		scale: {
			mode: Phaser.Scale.FIT,
			width,
			height,
			autoCenter: Phaser.Scale.CENTER_BOTH,
		},
		backgroundColor: settings.backgroundColor as string,
		parent: phaserMountElement
	};

	return phaserConfig;
}

export { config };

export default config;
